import { Navigate, useParams } from 'react-router-dom';

export default function CreateSubCommunityPage() {
  const { communityId } = useParams<{ communityId: string }>();
  const parent = communityId ? encodeURIComponent(communityId) : '';
  return (
    <Navigate to={`/create-community?tab=create${parent ? `&parent=${parent}` : ''}`} replace />
  );
}
